import styled from 'styled-components';

import Divider from '../common/Divider';

function MetricsTooltip({
  mainMetric,
  otherMetrics,
}: {
  mainMetric: { name: string; value: number };
  otherMetrics: Record<string, number>;
}) {
  return (
    <Tooltip>
      <MainMetric>
        <MainMetricName>{mainMetric.name}</MainMetricName>
        <MainMetricValue>{mainMetric.value}</MainMetricValue>
      </MainMetric>
      <Divider />
      {Object.entries(otherMetrics).map(([key, value]) => (
        <Metric key={key}>
          <MetricName>{key}</MetricName>
          <MetricValue>{value}</MetricValue>
        </Metric>
      ))}
    </Tooltip>
  );
}

const Tooltip = styled.div`
  display: flex;
  padding: var(--spacing-md);
  flex-direction: column;
  align-items: flex-end;
  gap: var(--spacing-sm);

  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--background);
  box-shadow: var(--elevation-toast);
`;

const MainMetric = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
`;

const MainMetricName = styled.div`
  color: var(--primary-hover);
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  font-style: normal;
  font-weight: var(--font-weight-medium);
  line-height: normal;
  letter-spacing: 1.92px;
  text-transform: uppercase;
`;

const MainMetricValue = styled.div`
  color: var(--primary);
  font-family: var(--font-primary);
  font-size: var(--text-xl);
  font-style: normal;
  font-weight: var(--font-weight-bold);
  line-height: normal;
`;

const Metric = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const MetricName = styled.div`
  color: var(--text-secondary);
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  font-style: normal;
  font-weight: var(--font-weight-normal);
  line-height: normal;
`;

const MetricValue = styled.div`
  color: var(--primary);
  text-align: right;
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  font-style: normal;
  font-weight: var(--font-weight-normal);
  line-height: normal;
`;

export default MetricsTooltip;
